import axios, { expertApi, extractData } from '@atheneum/api'
import find from 'lodash'
import { extendObservable } from 'mobx'

class ComplianceStore {
  constructor (growlStore) {
    this.growlStore = growlStore

    extendObservable(this, {
      complianceLanguages: [],
      currentLanguage: null,
      user: null,
      loading: false,
      employees: []
    })
    this.getComplianceLanguages()
  }

  getComplianceLanguages () {
    this.loading = true
    return axios
      .get('/api/compliance')
      .then(res => {
        this.complianceLanguages = extractData(res)
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.error = err
      })
  }

  getComplianceLanguage (languageName) {
    const languages = this.complianceLanguages.toJSON()
    const currentLanguage = languages.find(
      option => option.language.name === languageName
    )
    this.currentLanguage = languageName
    return currentLanguage
  }

  createBasicProfile = async (values, callback) => {
    const { phoneNum, phoneTypeId, email, latestExperiences } = values
    const userData = this.user

    if(phoneNum && userData.expert.phoneNum !== phoneNum) {
      const existingPhone = find(this.user.address.phones, {phoneNum: phoneNum})
      
      if(existingPhone) {
        userData.address.phones = this.user.address.phones.filter(phone => phone.phoneNum !== phoneNum)
      }
      if(userData.expert.phoneNum) {
        userData.address.phones.push({
          addressId: userData.address.id,
          phoneNum: userData.expert.phoneNum, 
          phoneTypeId: userData.expert.phoneTypeId
        })
      }
      userData.expert.phoneNum = phoneNum
    }
    userData.expert.phoneTypeId = phoneTypeId

    if(userData.email !== email) {
      let isNewEmail = true
      userData.address.emails = this.user.address.emails.map(e => {
        if(e.email === email) {
          isNewEmail = false
        }
        return e
      })

      if(isNewEmail) {
        userData.address.emails.push({email: email})
      }
    }
    userData.expert.isProfileCreated = true
    userData.expert.isProfileConfirmed = true

    userData.latestExperiences = latestExperiences.filter(ex => ex.company && ex.position && ex.startDate && (ex.endDate || ex.current))
    try {
      await expertApi.createBasicProfile(this.user.id, userData)
      
      return callback && callback()
    } catch (error) {
      this.growlStore.showError(error)
    }
  }

  expertComplianceEmailCheck (emailData) {
    this.loading = true
    return axios
      .post('/api/compliance/expert-email-check', emailData)
      .then(res => {
        this.user = extractData(res)

        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.error = err
      })
  }

  sendCompliance = async (expert, compliance, callback) => {
    const { language, referrer } = compliance
    try {
      await expertApi.sendCompliance({
        userId: expert.userId,
        languageId: language.id,
        referrer
      })

      this.growlStore.showSuccess(`Compliance in ${language.name} sent!`)
      return callback && callback(compliance)
    } catch (error) {
      this.growlStore.showError(error)
    }
  }

  setStaticComplianceSigned = async (expertId, referrerID) => {
    try {
      await expertApi.setStaticComplianceSigned(expertId, referrerID)
    } catch (error) {
      this.growlStore.showError(error)
    }
  }

  unsubscribe = async (payload, action, callback) => {
    try {
      const response = await expertApi.unsubscribe(payload)
      const { contactTypesToUpdate, blockedContactTypes } = response

      if (!contactTypesToUpdate) {
        return callback({contactTypesToUpdate: [], blockedContactTypes, noContactTypesToUpdate: true}, action)
      }

      this.growlStore.showSuccess(action)
      return callback && callback(response, action)
    } catch (error) {
      this.growlStore.showError(error)
    }
  }

  setStaticComplianceDeclined = async (expertId, callback) => {
    try {
      await expertApi.setStaticComplianceDeclined(expertId)
      this.growlStore.showSuccess(`Compliance declined`)
      return callback && callback()
    } catch (error) {
      this.growlStore.showError(error)
    }
  }

  sendAnonymousActionEmail = async (payload, callback) => {
    try {
      await expertApi.sendAnonymousActionEmail(payload)
      this.growlStore.showSuccess(`Anonymous action email sent`)
      return callback && callback()
    } catch (error) {
      this.growlStore.showError(error)
    }
  }
}

export default ComplianceStore
